import type {
    ApplyCommerceCartCouponRequest,
    ApplyCommerceCartCouponResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const applyCommerceCartCouponOperation = defineCommerceOperation<
    ApplyCommerceCartCouponRequest,
    ApplyCommerceCartCouponResponse
>("commerce.cart.coupons.apply");
